import { getRetailerActiveMemberships } from "@faire/help-center-utils/serialized-data/getRetailer";
import { intlDate } from "@faire/web/common/localization/date-fns/intlDate";
import { GoToMembershipSettingsCTA } from "./ctas";
export var CancelMembershipIA = function CancelMembershipIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2, context.brandOrder);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  var _getRetailerActiveMem;
  var membershipRenewalDate = (_getRetailerActiveMem = getRetailerActiveMemberships()) === null || _getRetailerActiveMem === void 0 ? void 0 : _getRetailerActiveMem.current_period_end_at;
  if (!membershipRenewalDate) {
    return CANCEL_MEMBERSHIP_GENERAL(strictLocalize);
  }
  return CANCEL_MEMBERSHIP_WITH_RENEWAL_DATE_INFO(strictLocalize, membershipRenewalDate);
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return GoToMembershipSettingsCTA(strictLocalize);
};
var CANCEL_MEMBERSHIP_GENERAL = function CANCEL_MEMBERSHIP_GENERAL(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return HOW_TO_CANCEL_MEMBERSHIP(strictLocalize);
    },
    getDescription: function getDescription() {
      return [IF_YOUR_MEMBERSHIP_RENEWS_ON(strictLocalize)];
    }
  };
};
var CANCEL_MEMBERSHIP_WITH_RENEWAL_DATE_INFO = function CANCEL_MEMBERSHIP_WITH_RENEWAL_DATE_INFO(strictLocalize, membershipRenewalDate) {
  return {
    getTitle: function getTitle() {
      return HOW_TO_CANCEL_MEMBERSHIP(strictLocalize);
    },
    getDescription: function getDescription() {
      return [IF_YOU_CANCEL_YOUR_MEMBERSHIP_BEFORE_RENEWAL_DATE(strictLocalize, membershipRenewalDate)];
    }
  };
};
var HOW_TO_CANCEL_MEMBERSHIP = function HOW_TO_CANCEL_MEMBERSHIP(strictLocalize) {
  return strictLocalize({
    id: "64Yg7u",
    defaultMessage: [{
      "type": 0,
      "value": "How to cancel your Insider membership"
    }]
  });
};
var IF_YOUR_MEMBERSHIP_RENEWS_ON = function IF_YOUR_MEMBERSHIP_RENEWS_ON(strictLocalize) {
  return strictLocalize({
    id: "2lMZeQ",
    defaultMessage: [{
      "type": 0,
      "value": "If you wish to cancel your Insider membership, you can do so through the \"Insider Membership\" tab within your Account settings. Should you decide to cancel before your next billing date, your membership will conclude at the end of the ongoing billing cycle. For instance, if your membership is scheduled to renew on 30 June and you cancel it on 15 June, your membership access will continue until 30 June. You will have access to your Insider benefits up until that date."
    }]
  });
};
var IF_YOU_CANCEL_YOUR_MEMBERSHIP_BEFORE_RENEWAL_DATE = function IF_YOU_CANCEL_YOUR_MEMBERSHIP_BEFORE_RENEWAL_DATE(strictLocalize, renewalDate) {
  return strictLocalize({
    id: "/4fXeB",
    defaultMessage: [{
      "type": 0,
      "value": "If you wish to cancel your Insider membership, you can do so through the \"Insider Membership\" tab within your Account settings. Should you decide to cancel your membership before the next billing date, your membership will conclude at the end of the ongoing billing cycle. For instance, if you cancel your membership before "
    }, {
      "type": 1,
      "value": "renewalDate"
    }, {
      "type": 0,
      "value": ", your membership will not renew, but you will still have access to your Insider benefits up until that date."
    }]
  }, {
    renewalDate: intlDate(renewalDate, "MMMM d")
  });
};